import React from "react";
import { Redirect, Route } from "react-router-dom";
import { ReducerStates, Views } from "../../helpers/constants";
import { useAppSelector } from "./appHooks";

// Prevents users that are not logged from accessing pages that required to be logged in
const PrivateRoute: React.FC<{
  component: React.FC;
  path: string;
  exact: boolean;
}> = (props) => {
  const isLogged = useAppSelector((state) => state.loginState.isLogged);
  const dashboardState = useAppSelector((state) => state.dashboardState.state);

  return isLogged ? (
    <Route path={props.path} exact={props.exact} component={props.component} />
  ) : dashboardState === ReducerStates.FAILED ? (
    <Redirect to={Views.ACCESS_EXPIRED} />
  ) : (
    <Redirect to={Views.LOGIN} />
  );
};
export default PrivateRoute;
